import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-钻井跟踪_地质导向",
  "use": "icon-钻井跟踪_地质导向-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-钻井跟踪_地质导向\">\n<g>\n\t<g>\n\t\t<path d=\"M11.3,1.2L13,2.4v9.9H9.6V2.4L11.3,1.2 M11.3,0L8.6,1.8v11.4H14V1.8L11.3,0L11.3,0z\" />\n\t</g>\n\t<g>\n\t\t<path d=\"M6.3,2.8v10l-1.7,1.8l-1.7-1.8v-10H6.3 M7.3,1.8H1.9v11.4L4.6,16l2.7-2.8V1.8L7.3,1.8z\" />\n\t</g>\n\t<rect y=\"7.5\" width=\"16\" height=\"1\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol